import React, { useState } from "react";
import { VisualContent } from "../../../../interfaces/domain/menu";
import { useContentCard } from "../../../../hooks/useContenCarrouselCard";
import styles from "./ContentCard.module.scss";

interface ContentCardProps {
  content: VisualContent;
  // above the fold → primer banner carga eager
  priority?: boolean;
}

export const ContentCard = React.memo(({ content, priority = false }: ContentCardProps) => {
  const { imageUrl, isClickable, handleNavigation, hasTextOverlay } = useContentCard(content);
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className={`${styles.contentCard} ${!loaded ? styles.skeleton : ""}`}
      onClick={handleNavigation}
      role={isClickable ? "button" : "img"}
      tabIndex={isClickable ? 0 : -1}
      style={{ cursor: isClickable ? "pointer" : "default" }}
      aria-label={content.title || "Banner"}
    >
      <img
        src={imageUrl}
        alt={content.title || "Banner"}
        className={`${styles.contentImage} ${loaded ? styles.visible : styles.hidden}`}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        onLoad={() => setLoaded(true)}
      />

      {hasTextOverlay && loaded && (
        <div className={styles.contentOverlay}>
          <h3 className={styles.contentTitle}>{content.title}</h3>
        </div>
      )}
    </div>
  );
});
